module.exports = __webpack_public_path__ + "static/img_2483-f8664753818525e5e34c2c7180ee1bdb.webp";